// eslint-disable-next-line no-restricted-imports
import { toast as libToast } from 'vuetify-sonner'

const toastOptions = {
  prependIcon: null,
  action: {
    buttonProps: {
      appendIcon: 'close',
      variant: 'text',
      density: 'compact',
    },
  },
} as unknown as any

export const toast = {
  success: (message: string, description?: string) => libToast.success(message, { ...toastOptions, description }),
  error: (message: string, description?: string) => libToast.error(message, { ...toastOptions, description }),
  warning: (message: string, description?: string) => libToast.warning(message, { ...toastOptions, description }),
}
